<i18n>
  {
    "en": {
      "onlinecity": "ONLINECITY.IO",
      "about": "About",
      "crew": "Crew",
      "clients": "Clients",
      "facts": "Facts",
      "vacant_positions": "Vacant positions",
      "our_blog": "Our blog",
      "our_offices": "Our offices",
      "passion": "Passion",
      "contact_us": "Contact us"
    },
    "da": {
      "onlinecity": "ONLINECITY.IO",
      "about": "Om",
      "crew": "Holdet",
      "clients": "Kunder",
      "facts": "Fakta",
      "vacant_positions": "Stillinger",
      "our_blog": "Vores blog",
      "our_offices": "Vores kontorer",
      "passion": "Passion",
      "contact_us": "Kontakt os"
    }
  }
</i18n>

  <template>
    <!--
  <nav class="section-nav" v-show="!scrollLocked" :class="{'inverted': optimizeScrollNav}" @mouseenter="">
    <ul>
      <li
        v-for="(item, index) in navItems"
        :name="item.name"
        :title="item.title"
        :class="{'is-active': (item.name.toLowerCase() === activeSectionName)}"
        @click.prevent="scrollToSection(item)">
        <div class="nav-item-dot-outer">
          <div class="nav-item-dot"></div>
        </div>
        <div class="nav-item-title" href="#">{{ $t(item.title) }}</div>
      </li>
    </ul>
  </nav>-->
</template>

<script>
  import ScrollToPlugin from 'gsap/ScrollToPlugin'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'SectionNav',
    data () {
      return {
        scrollTo: ScrollToPlugin
      }
    },
    mounted () {
      this.checkScrollAnimation()
    },
    computed: {
      ...mapGetters({
        navItems: 'getNavItems',
        scrollLocked: 'getScrollLockState',
        isAnimating: 'getAnimatingScrollState',
        activeSectionName: 'getActiveSectionName',
        scroll_pos: 'getScrollPos'
      }),
      optimizeScrollNav () {
        return (
          this.activeSectionName === 'about'
          || this.activeSectionName === 'site-footer'
          || this.activeSectionName === 'blog'
        )
      }
    },
    methods: {
      ...mapActions([
        'setActiveSection',
        'setAnimatingScrollState'
      ]),
      checkScrollAnimation () {
        /*
        let _this = this
        setInterval(() => {
          if (!TweenMax.isTweening(window)) {
            _this.setAnimatingScrollState(false)
          }
        }, 200)
        */
      },
      scrollToSection (section) {
        /*
        let _this = this
        if (this.isAnimating) return
        this.setActiveSection(section.name.toLowerCase())
        TweenMax.to(window, 1.5, {
          scrollTo: {
            y: section.scroll_to
          },
          ease: Power4.easeInOut,
          onStart () {
            _this.setAnimatingScrollState(true)
          }
        })
        */
      }
    }
  }
</script>

<style lang="scss">
  .nav-item-dot-outer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    .nav-item-dot {
      width: 15px;
      height: 15px;
      border-radius: 50%;
      border: 2px solid #2d2d2e;
    }
  }
  .nav-item-title {
    height: 26px;
    opacity: 0;
    visibility: hidden;
    color: #2d2d2e;
    line-height: 28px;
    padding-left: 2px;
    text-transform: uppercase;
    transform: translateX(-12px);
    transition: transform .15s cubic-bezier(0.23, 1, 0.320, 1);
    font-family: "Gotham Rounded SSm A", "Gotham Rounded SSm B";
    @media screen and (max-width: 768px) {
      position: absolute;
    }
  }
  .section-nav {
    position: fixed;
    height: 100%;
    top: 0;
    z-index: 990;
    background-color: rgba(0, 0, 0, 0);
    transition: background-color .1s cubic-bezier(0.23, 1, 0.320, 1) .15s;
    transition: transform .15s cubic-bezier(0.23, 1, 0.320, 1);
    transform: translateX(28px);
    @media screen and (max-width: 768px) {
      transform: translateX(0);
    }
    ul {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      > li {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        white-space: pre;
        cursor: pointer;
        &.is-active {
          .nav-item-dot {
            background-color: #f5683b;
            border-color: #f5683b;
          }
        }
        &.is-active, &:hover {
          .nav-item-title {
            opacity: 1;
            visibility: inherit;
            transform: translateX(0);
            transition: all .4s cubic-bezier(0.23, 1, 0.320, 1);
            @media screen and (max-width: 768px) {
              opacity: 0;
              visibility: hidden;
            }
          }
          .nav-item-dot {
            border-color: #f5683b;
          }
        }
        @media screen and (max-width: 768px) {
          width: 30px;
          overflow: hidden;

        }
        &:hover {
          @media screen and (max-width: 768px) {
            .nav-item-title {
              position: absolute;
              opacity: 0;
              visibility: hidden;
            }
          }
        }
        &.is-active {
          @media screen and (max-width: 768px) {
            .nav-item-title {
              position: absolute;
              opacity: 0;
              visibility: hidden;
            }
          }
        }
      }
    }
    &.inverted {
      .nav-item-dot {
        border-color: #fff;
      }
      .nav-item-title {
        color: #fff;
      }
    }
    &.optimize {
      @media screen and (max-width: 768px) {
        display: block;
      }
      .nav-item-title {
        transition: none;
        padding-right: 1rem;
        border-top-right-radius: 13px;
        border-bottom-right-radius: 13px;
        left: 34px;
        transform: translate(0);
      }
      ul {
        > li {
          &.is-active, &:hover {
            @media screen and (max-width: 768px) {
              justify-content: center;
            }
            .nav-item-title {
              transition: none;
              left: 34px;
              @media screen and (max-width: 768px) {
                position: absolute;
                opacity: 0;
                visibility: hidden;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SectionNav.vue